var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g3, _path14, _path15, _g4, _path16, _g5, _path17, _g6, _path18, _g7, _path19, _g8, _path20, _g9, _path21, _g0, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13495_34350)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13495_34350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 11,
    width: 20,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11H33.2502V39.6777H14V11Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13495_34350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3727 38.4346H16.7177C15.9184 38.4346 15.2656 37.7819 15.2656 36.9781V19.2733H31.8292V36.9781C31.8292 37.7819 31.1764 38.4346 30.3727 38.4346ZM16.7177 12.2748H30.3727C31.1764 12.2748 31.8292 12.932 31.8292 13.7358V18.0121H15.2656V13.7358C15.2656 12.932 15.9184 12.2748 16.7177 12.2748ZM30.3727 11.0137H16.7177C15.2212 11.0137 14 12.2348 14 13.7358V36.9781C14 38.4791 15.2212 39.7002 16.7177 39.7002H30.3727C31.8736 39.7002 33.0948 38.4791 33.0948 36.9781V13.7358C33.0948 12.2348 31.8736 11.0137 30.3727 11.0137Z",
    fill: "#06513D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9468 16.4437H17.1578V14.0191H29.9468V16.4437ZM30.7017 13.2598H16.3984V17.2031H30.7017V13.2598Z",
    fill: "#06513D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8697 22.3556C19.8697 22.7152 19.5722 23.0128 19.2125 23.0128H17.4673C17.1032 23.0128 16.8101 22.7152 16.8101 22.3556V21.272C16.8101 20.9079 17.1032 20.6148 17.4673 20.6148H19.2125C19.5722 20.6148 19.8697 20.9079 19.8697 21.272V22.3556ZM19.2125 19.8555H17.4673C16.6858 19.8555 16.0508 20.4905 16.0508 21.272V22.3556C16.0508 23.1327 16.6858 23.7721 17.4673 23.7721H19.2125C19.9896 23.7721 20.6246 23.1327 20.6246 22.3556V21.272C20.6246 20.4905 19.9896 19.8555 19.2125 19.8555Z",
    fill: "#06513D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0762 22.3556C25.0762 22.7152 24.7831 23.0128 24.419 23.0128H22.6783C22.3142 23.0128 22.0166 22.7152 22.0166 22.3556V21.272C22.0166 20.9079 22.3142 20.6148 22.6783 20.6148H24.419C24.7831 20.6148 25.0762 20.9079 25.0762 21.272V22.3556ZM24.419 19.8555H22.6783C21.8967 19.8555 21.2617 20.4905 21.2617 21.272V22.3556C21.2617 23.1327 21.8967 23.7721 22.6783 23.7721H24.419C25.2006 23.7721 25.8356 23.1327 25.8356 22.3556V21.272C25.8356 20.4905 25.2006 19.8555 24.419 19.8555Z",
    fill: "#06513D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2916 22.3556C30.2916 22.7152 29.9941 23.0128 29.6344 23.0128H27.8892C27.5295 23.0128 27.232 22.7152 27.232 22.3556V21.272C27.232 20.9079 27.5295 20.6148 27.8892 20.6148H29.6344C29.9941 20.6148 30.2916 20.9079 30.2916 21.272V22.3556ZM29.6344 19.8555H27.8892C27.1121 19.8555 26.4727 20.4905 26.4727 21.272V22.3556C26.4727 23.1327 27.1121 23.7721 27.8892 23.7721H29.6344C30.4159 23.7721 31.051 23.1327 31.051 22.3556V21.272C31.051 20.4905 30.4159 19.8555 29.6344 19.8555Z",
    fill: "#06513D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8697 26.9995C19.8697 27.3637 19.5722 27.6568 19.2125 27.6568H17.4673C17.1032 27.6568 16.8101 27.3637 16.8101 26.9995V25.916C16.8101 25.5563 17.1032 25.2588 17.4673 25.2588H19.2125C19.5722 25.2588 19.8697 25.5563 19.8697 25.916V26.9995ZM19.2125 24.5039H17.4673C16.6858 24.5039 16.0508 25.1389 16.0508 25.916V26.9995C16.0508 27.7811 16.6858 28.4161 17.4673 28.4161H19.2125C19.9896 28.4161 20.6246 27.7811 20.6246 26.9995V25.916C20.6246 25.1389 19.9896 24.5039 19.2125 24.5039Z",
    fill: "#06513D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0762 26.9995C25.0762 27.3637 24.7831 27.6568 24.419 27.6568H22.6783C22.3142 27.6568 22.0166 27.3637 22.0166 26.9995V25.916C22.0166 25.5563 22.3142 25.2588 22.6783 25.2588H24.419C24.7831 25.2588 25.0762 25.5563 25.0762 25.916V26.9995ZM24.419 24.5039H22.6783C21.8967 24.5039 21.2617 25.1389 21.2617 25.916V26.9995C21.2617 27.7811 21.8967 28.4161 22.6783 28.4161H24.419C25.2006 28.4161 25.8356 27.7811 25.8356 26.9995V25.916C25.8356 25.1389 25.2006 24.5039 24.419 24.5039Z",
    fill: "#06513D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2916 26.9995C30.2916 27.3637 29.9941 27.6568 29.6344 27.6568H27.8892C27.5295 27.6568 27.232 27.3637 27.232 26.9995V25.916C27.232 25.5563 27.5295 25.2588 27.8892 25.2588H29.6344C29.9941 25.2588 30.2916 25.5563 30.2916 25.916V26.9995ZM29.6344 24.5039H27.8892C27.1121 24.5039 26.4727 25.1389 26.4727 25.916V26.9995C26.4727 27.7811 27.1121 28.4161 27.8892 28.4161H29.6344C30.4159 28.4161 31.051 27.7811 31.051 26.9995V25.916C31.051 25.1389 30.4159 24.5039 29.6344 24.5039Z",
    fill: "#06513D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8697 31.6485C19.8697 32.0127 19.5722 32.3057 19.2125 32.3057H17.4673C17.1032 32.3057 16.8101 32.0127 16.8101 31.6485V30.565C16.8101 30.2009 17.1032 29.9078 17.4673 29.9078H19.2125C19.5722 29.9078 19.8697 30.2009 19.8697 30.565V31.6485ZM19.2125 29.1484H17.4673C16.6858 29.1484 16.0508 29.7834 16.0508 30.565V31.6485C16.0508 32.4301 16.6858 33.0651 17.4673 33.0651H19.2125C19.9896 33.0651 20.6246 32.4301 20.6246 31.6485V30.565C20.6246 29.7834 19.9896 29.1484 19.2125 29.1484Z",
    fill: "#06513D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0762 31.6485C25.0762 32.0127 24.7831 32.3057 24.419 32.3057H22.6783C22.3142 32.3057 22.0166 32.0127 22.0166 31.6485V30.565C22.0166 30.2009 22.3142 29.9078 22.6783 29.9078H24.419C24.7831 29.9078 25.0762 30.2009 25.0762 30.565V31.6485ZM24.419 29.1484H22.6783C21.8967 29.1484 21.2617 29.7834 21.2617 30.565V31.6485C21.2617 32.4301 21.8967 33.0651 22.6783 33.0651H24.419C25.2006 33.0651 25.8356 32.4301 25.8356 31.6485V30.565C25.8356 29.7834 25.2006 29.1484 24.419 29.1484Z",
    fill: "#06513D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8697 36.2989C19.8697 36.6586 19.5722 36.9561 19.2125 36.9561H17.4673C17.1032 36.9561 16.8101 36.6586 16.8101 36.2989V35.2154C16.8101 34.8513 17.1032 34.5537 17.4673 34.5537H19.2125C19.5722 34.5537 19.8697 34.8513 19.8697 35.2154V36.2989ZM19.2125 33.7988H17.4673C16.6858 33.7988 16.0508 34.4338 16.0508 35.2154V36.2989C16.0508 37.076 16.6858 37.711 17.4673 37.711H19.2125C19.9896 37.711 20.6246 37.076 20.6246 36.2989V35.2154C20.6246 34.4338 19.9896 33.7988 19.2125 33.7988Z",
    fill: "#06513D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0762 36.2989C25.0762 36.6586 24.7831 36.9561 24.419 36.9561H22.6783C22.3142 36.9561 22.0166 36.6586 22.0166 36.2989V35.2154C22.0166 34.8513 22.3142 34.5537 22.6783 34.5537H24.419C24.7831 34.5537 25.0762 34.8513 25.0762 35.2154V36.2989ZM24.419 33.7988H22.6783C21.8967 33.7988 21.2617 34.4338 21.2617 35.2154V36.2989C21.2617 37.076 21.8967 37.711 22.6783 37.711H24.419C25.2006 37.711 25.8356 37.076 25.8356 36.2989V35.2154C25.8356 34.4338 25.2006 33.7988 24.419 33.7988Z",
    fill: "#06513D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2916 36.2002C30.2916 36.5643 29.9941 36.8574 29.6344 36.8574H27.8892C27.5295 36.8574 27.232 36.5643 27.232 36.2002V30.565C27.232 30.2009 27.5295 29.9078 27.8892 29.9078H29.6344C29.9941 29.9078 30.2916 30.2009 30.2916 30.565V36.2002ZM29.6344 29.1484H27.8892C27.1121 29.1484 26.4727 29.7834 26.4727 30.565V36.2002C26.4727 36.9817 27.1121 37.6167 27.8892 37.6167H29.6344C30.4159 37.6167 31.051 36.9817 31.051 36.2002V30.565C31.051 29.7834 30.4159 29.1484 29.6344 29.1484Z",
    fill: "#06513D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13495_34350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 20,
    width: 16,
    height: 17
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4883 20.8418H40.6975V36.051H25.4883V20.8418Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13495_34350)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13495_34350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 20,
    width: 16,
    height: 17
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0946 20.8418C28.8937 20.8418 25.4922 24.2478 25.4922 28.4486C25.4922 32.6495 28.8937 36.051 33.0946 36.051C37.2954 36.051 40.7014 32.6495 40.7014 28.4486C40.7014 24.2478 37.2954 20.8418 33.0946 20.8418Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13495_34350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4922 20.8418H40.7014V36.051H25.4922V20.8418Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13495_34350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 20,
    width: 16,
    height: 16
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4883 20.8418H40.6442V35.9977H25.4883V20.8418Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13495_34350)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_13495_34350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 20,
    width: 16,
    height: 17
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0946 20.8418C28.8937 20.8418 25.4922 24.2478 25.4922 28.4442C25.4922 32.645 28.8937 36.051 33.0946 36.051C37.2954 36.051 40.7014 32.645 40.7014 28.4442C40.7014 24.2478 37.2954 20.8418 33.0946 20.8418Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_13495_34350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0946 20.8418C28.8937 20.8418 25.4922 24.2478 25.4922 28.4442C25.4922 32.645 28.8937 36.051 33.0946 36.051C37.2954 36.051 40.7014 32.645 40.7014 28.4442C40.7014 24.2478 37.2954 20.8418 33.0946 20.8418Z",
    stroke: "#06513D",
    strokeWidth: 1.99822
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_13495_34350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 27,
    width: 2,
    height: 3
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9141 27.3027H37.931V29.5763H36.9141V27.3027Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_13495_34350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.132 27.8937C36.9455 28.0847 36.8922 28.3422 37.0165 28.4666C37.1453 28.5909 37.4029 28.542 37.5894 28.3511C37.7803 28.1646 37.8292 27.907 37.7048 27.7783C37.5805 27.6539 37.3229 27.7072 37.132 27.8937Z",
    fill: "#06513D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_13495_34350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 26,
    width: 3,
    height: 3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7812 26.1641H37.935V28.4377H35.7812V26.1641Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_13495_34350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1465 26.6425C36.8933 26.8957 36.8267 27.2376 36.9955 27.4063C37.1642 27.5751 37.5061 27.504 37.7593 27.2509C38.0124 27.0022 38.079 26.6603 37.9102 26.4916C37.7415 26.3228 37.3996 26.3894 37.1465 26.6425Z",
    fill: "#06513D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_13495_34350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 25,
    width: 3,
    height: 3
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7812 25.0254H37.935V27.299H35.7812V25.0254Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_13495_34350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8238 25.3464C36.5085 25.6617 36.4242 26.0924 36.6373 26.3012C36.846 26.5099 37.2723 26.4255 37.5876 26.1102C37.9029 25.7949 37.9873 25.3686 37.7786 25.1555C37.5699 24.9468 37.1436 25.0311 36.8238 25.3464Z",
    fill: "#06513D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_13495_34350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 23,
    width: 4,
    height: 4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6445 23.8926H37.935V26.1662H34.6445V23.8926Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_13495_34350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0202 24.3249C35.6827 24.6624 35.5984 25.1198 35.8293 25.3507C36.0602 25.5861 36.522 25.4973 36.8595 25.1598C37.197 24.8267 37.2814 24.3649 37.0505 24.134C36.8196 23.9031 36.3577 23.9874 36.0202 24.3249Z",
    fill: "#06513D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_13495_34350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 22,
    width: 4,
    height: 4
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5039 22.7754H36.9143V25.0268H33.5039V22.7754Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_13495_34350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6417 23.3382C34.2021 23.7778 34.0822 24.3773 34.3753 24.6704C34.6684 24.9635 35.2678 24.848 35.7075 24.4039C36.1515 23.9599 36.2714 23.3648 35.9739 23.0717C35.6808 22.7742 35.0858 22.8941 34.6417 23.3382Z",
    fill: "#06513D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_13495_34350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 25,
    width: 9,
    height: 10
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0977 25.0254H36.9123V34.1198H28.0977V25.0254Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_13495_34350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8975 28.7404V28.9402H35.3024V28.7493L35.6621 28.0699C35.6977 28.0033 35.6977 27.9633 35.6977 27.8834C35.6977 27.8168 35.6977 27.7324 35.6 27.7324C35.5422 27.7324 35.5023 27.7679 35.5023 27.8301V27.9455H35.3024V27.8345C35.3024 27.6658 35.4357 27.5326 35.6044 27.5326C35.8131 27.5326 35.8975 27.6969 35.8975 27.8834C35.8975 28.0166 35.8931 28.0521 35.8309 28.172L35.5378 28.7404H35.8975ZM35.0937 28.0388C35.0937 28.4296 34.8007 28.625 34.5209 28.625C34.2411 28.625 33.9436 28.4296 33.9436 28.0388V26.7732C33.9436 26.3824 34.2411 26.187 34.5209 26.187C34.8007 26.187 35.0937 26.3824 35.0937 26.7732V28.0388ZM33.6861 26.8931H33.3397V26.7776C33.3397 26.6444 33.2597 26.529 33.131 26.529C32.9578 26.529 32.9178 26.6489 32.9178 26.8087V28.0343C32.9178 28.172 32.9711 28.2786 33.1265 28.2786C33.2198 28.2786 33.3397 28.2253 33.3397 28.0388V27.9189H33.6861V28.0699C33.6861 28.363 33.4463 28.625 33.1399 28.625C32.8779 28.625 32.5715 28.4962 32.5715 28.0566V26.7377C32.5715 26.4268 32.7979 26.187 33.131 26.187C33.4507 26.187 33.6861 26.4268 33.6861 26.7599V26.8931ZM35.9597 25.7696C34.8007 24.6062 33.1621 25.1124 32.3006 25.9206C32.1718 26.0405 31.9009 26.2936 31.7588 26.7066C31.6522 26.9997 31.5901 27.4571 31.5323 28.0077C31.4657 28.656 31.4968 28.8337 31.4258 29.0468C31.3858 29.1712 31.2748 29.4598 31.035 29.7618C30.7685 30.0948 30.4799 30.2724 30.36 30.3435C30.1602 30.4545 30.0758 30.4589 29.7872 30.57C29.5918 30.6454 29.0989 30.8453 28.868 31.0318C28.264 31.5247 28.0997 32.6393 28.868 33.4031C29.5163 34.0514 30.6531 34.1136 31.2393 33.4031C31.5457 33.0345 31.9542 32.435 32.6159 31.8577C32.829 31.6712 33.0777 31.4758 34.1035 30.7875C34.5609 30.4856 35.2492 30.1481 35.9597 29.5797C37.1142 28.656 37.0077 26.8132 35.9597 25.7696Z",
    fill: "#06513D"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5244 26.5293C34.4001 26.5293 34.2891 26.6092 34.2891 26.7735V28.0391C34.2891 28.2034 34.4001 28.2789 34.5244 28.2789C34.6488 28.2789 34.7553 28.2034 34.7553 28.0391V26.7735C34.7553 26.6092 34.6488 26.5293 34.5244 26.5293Z",
    fill: "#06513D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13495_34350",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13495_34350"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13495_34350",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardn);
export default __webpack_public_path__ + "static/media/dashboardn.2fce6f093ab6a234d49a860cd1c71a22.svg";
export { ForwardRef as ReactComponent };